export const LEGACY_STREET_ADDRESS_KEY = "deliveryAddress";
export class LegacyStreetAddressStorageManager {
    store(streetAddressData) {
        const previousDataString = localStorage.getItem(LEGACY_STREET_ADDRESS_KEY);
        let data = {};
        // eslint-disable-next-line
        if (previousDataString !== null) {
            data = JSON.parse(previousDataString);
        }
        // eslint-disable-next-line
        data = { ...data, ...streetAddressData };
        const legacyStreetAddressDataString = JSON.stringify(data);
        localStorage.setItem(LEGACY_STREET_ADDRESS_KEY, legacyStreetAddressDataString);
    }
    restore() {
        const legacyStreetAddressDataString = localStorage.getItem(LEGACY_STREET_ADDRESS_KEY);
        if (legacyStreetAddressDataString === null) {
            return null;
        }
        return JSON.parse(legacyStreetAddressDataString);
    }
    erase() {
        throw new Error("Method not implemented.");
    }
}
